const pixel = window.fbq;

export const clickOnConfirmReservation = (country, iddeporte, idrsvp, idcentro, idsede, idcancha, tarifa, timestamprsvp, timestamprsvpend) => {
  if (pixel) {
    pixel('trackCustom', 'submit_reservation', { country, iddeporte, idrsvp, idcentro, idsede, idcancha, tarifa, timestamprsvp, timestamprsvpend });
  }
};
